// extracted by mini-css-extract-plugin
export default {"mainGrid":"MarginToCarbon_mainGrid__WD7bJ","chartFlex":"MarginToCarbon_chartFlex__xl-hp","chartContainer":"MarginToCarbon_chartContainer__S9UiW"};